import React from 'react';
import { FemEntityLanding } from './pages/FemEntityLanding';
import { InvestorsPage } from './pages/InvestorsPage';
import { PractitionersPage } from './pages/PractitionersPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { AppLaunchPage } from './pages/AppLaunchPage';
import { PractitionerJoinPage } from './pages/PractitionerJoinPage';
import { PractitionerWelcomePage } from './pages/PractitionerWelcomePage';
import { TermsOfServicePage } from './pages/TermsOfServicePage';
import { TermsOfSalePage } from './pages/TermsOfSalePage';
export function App() {
  const path = window.location.pathname.replace(/\/+$/, '') || '/';
  if (path === '/investors') {
    return <InvestorsPage data-id="element-0" data-mp="2wk9y4kb1ymz3" />;
  }
  if (path === '/practitioners/join') {
    return <PractitionerJoinPage initialStep="account" data-id="element-1" data-mp="2wi5nzkmk8rqd" />;
  }
  if (path === '/practitioners/membership') {
    return <PractitionerJoinPage initialStep="membership" data-id="element-2" data-mp="23vcjcr61v8b3" />;
  }
  if (path === '/practitioners/welcome') {
    return <PractitionerWelcomePage data-id="element-3" data-mp="3ik7gwiph6frp" />;
  }
  if (path === '/terms-of-service') {
    return <TermsOfServicePage data-id="element-4" data-mp="3ii4sg33z0up3" />;
  }
  if (path === '/terms-of-sale') {
    return <TermsOfSalePage data-id="element-5" data-mp="3mjztr7lwj82v" />;
  }
  if (path === '/practitioners') {
    return <PractitionersPage data-id="element-6" data-mp="3rbzngibdp4r0" />;
  }
  if (path === '/privacy-policy') {
    return <PrivacyPolicyPage data-id="element-7" data-mp="5ot150vj28n" />;
  }
  if (path === '/get-the-app') {
    return <AppLaunchPage data-id="element-8" data-mp="82kz509bybz" />;
  }
  return <FemEntityLanding data-id="element-9" data-mp="2zld2xbxu5jcl" />;
}